var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomCalc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.646.375H.375v2.25h12.271V.375zM4.42 2.71H.375v9.893H4.42V2.712zM14.282 7.766H9.665v1.522h4.617V7.766z",
    stroke: "#000",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 6.375h-7.25v9.25h7.25v-9.25z",
    stroke: "#000",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.29 11h-1v1h1v-1zM12.5 11h-1v1h1v-1zM14.657 11h-1v1h1v-1zM14.657 13.336h-1v1h1v-1zM12.5 13.336h-1v1h1v-1zM10.29 13.336h-1v1h1v-1z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5V3M12.625 5V3",
    stroke: "#000",
    strokeWidth: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.597 5.861h6.1M.6 9.164h6.1M.6 12.479h6.1",
    stroke: "#000"
  })));
}

export default SvgCustomCalc;